import React from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { NavBar } from '../../../ui/NavBar/NavBar';
import { JobPostTable } from './containers';
import { JobPostDetails } from './JobPostDetails';

export const JobPostingView = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <Box sx={{ bgcolor: 'grey.100', minHeight: '100vh' }}>
      <NavBar variant="job_posting" />
      <Box sx={{ pt: 'var(--nav-height,3.5rem)' }}>
        {id ? (
          <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
            <JobPostDetails />
          </Box>
        ) : (
          <JobPostTable />
        )}
      </Box>
    </Box>
  );
};
